<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">万达影城</div>
          <div class="contentBottom">
            <div>万传统影厅到数字化影厅的进阶</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">项目背景</div>
      <div class="lineCss"></div>
    </div>
    <!-- start -->
    <!-- start -->
    <div class="productParent marginTop109">
      <div class="productLeft">
        <img :src="productLeft1">
      </div>
      <div class="productRight">
        <div class="productRightText">
          万达影城是院线行业的标杆品牌，在发展和创新方面一直处于领头羊位置。随着智能科技的发展，万达也致力于提升智能化的观影体验，并希望应用新技术来提高更多收益。通过智能化改造，希望达到以下目标：
          <br>1.一个能管理全国所有门店屏幕的平台
          <br>2.具备开放的数据接口，让票价屏实时展示票务信息
          <br>3.屏幕除了满足基本需求（展示卖品和票价），还能为影院带来收益
          <br>4.平台稳定，可支持终端硬件随时扩容
        </div>
      </div>
    </div>
    <!-- end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:152px">方案策略</div>
      <div class="lineCss"></div>
    </div>
    <div class="grayBox">
      <div
        class="grayBoxText"
      >用数拓平台独家研发的云拼接技术，让原有单独展示的屏幕可成为拼接组，实现单联屏按时序切换。同时，通过H5模板对接影城原有的排片数据，实现实时更新。联屏的效果极大的提升了屏幕的视觉占有率，也就增加了屏幕的广告价值，让屏幕从自用到为影城带来额外收益。</div>
      <!-- detailList start -->
      <div class="detailList">
        <div class="detailBox">
          <img :src="detailListIcon1" alt>
          <div class="detailBoxTitle">私有云服务</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon2" alt>
          <div class="detailBoxTitle">排片数据对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon3" alt>
          <div class="detailBoxTitle">长联屏广告播放策略</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon4" alt>
          <div class="detailBoxTitle">视频、模版定制服务</div>
        </div>
      </div>
      <!-- detailList end -->
    </div>
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:152px">场景功能</div>
      <div class="lineCss"></div>
    </div>
    <div class="leftYellowParent">
      <!-- <div class="leftYellow"></div> -->
      <div class="bottomParent">
        <div class="bottomLeft" style="width:50%;padding:0;">
          <img :src="wanDaContent2" alt>
        </div>
        <div class="bottomRight">
          <div class="bottomRightTitle">云拼接，单屏/联动自动切换</div>
          <div
            class="bottomRightText"
          >屏幕接入数拓网络播放盒，实现屏幕入网，通过“瓦片”式拼接技术，实现联屏展示。联屏内容结束，自动切换单屏展示票价、卖品信息。长联屏视觉效果震撼，展示广告或片花更吸引注意，为万达带来了额外收益。</div>
        </div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">排片对接，实时展示</div>
        <div class="bottomRightText bottomRightTextTwo">定制化票价模板，对接万达排片数据库，让票价屏实时展示票务信息。</div>
      </div>

      <div class="bottomRight" style='width:50%;'>
        <img :src="wanDaContent3" alt>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft" style="width:50%;padding:0;">
        <img :src="wanDaContent4" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle">长联屏内容定制，广告收益翻倍</div>
        <div
          class="bottomRightText"
        >数拓为万达提供长联屏片花定制服务，通过专业的视频定制流程，专用的渲染工作站，进行代码级压缩，保证视频文件小而高清。让用户能随时了解最新的电影资讯，提升影片的宣传效果，也为万达增加了收益。</div>
      </div>
    </div>
    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/wanDaTop.png";
import productLeft1 from "@/assets/images/wanDaContent1.png";

import wanDaContent2 from "@/assets/images/wanDaContent2.png";
import wanDaContent3 from "@/assets/images/wanDaContent3.png";
import wanDaContent4 from "@/assets/images/wanDaContent4.png";
import detailListIcon1 from "@/assets/images/detailListIcon1.png";
import detailListIcon2 from "@/assets/images/wanDaAnLiIcon2.png";
import detailListIcon3 from "@/assets/images/wanDaAnLiIcon3.png";
import detailListIcon4 from "@/assets/images/wanDaAnLiIcon4.png";

import Bread from "@/components/bread.vue";

export default {
  name: "CaseDetailWanDa",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["案例", "万达影城"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      productLeft1: productLeft1,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 180px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 77px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  max-width: 1200px;
  margin: auto;
}

.productLeft {
  width: 51%;
  float: left;
}

.productLeft img {
  width: 98%;
  /* max-width: 542px; */
}

.productRight {
  width: 46%;
  padding-left: 2%;
  float: left;
}

.productRightTitle {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 2%;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
  margin-top: 3px;
}

.marginTop109 {
  margin-top: 59px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 58px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 54px;
  padding-bottom: 64px;
  padding-top: 94px;
}

.detailList {
  display: flex;
  width: 70%;
  margin: auto;
}

.detailBox {
  width: 25%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.productParent {
  margin-top: 50px;
}
.bottomParent {
  width: 70%;
  max-width: 1200px;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 40%;
  float: left;
  padding-left: 10%;
  margin-top: 84px;
}
.bottomLeft img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 40%;
  float: right;
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 6%;
}
.bottomRightText {
  width: 90%;
  margin-top: 10%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.bottomRightTitleTwo {
}
.bottomRightTextTwo {
  width: 80%;
  margin-top: 6%;
}
/* 左边 left  start */
.leftYellowParent {
  position: relative;
}
.leftYellow {
  position: absolute;
  left: 0;
  top: 160px;
  width: 12.5%;
  height: 80px;
  background: rgba(252, 200, 0, 1);
}
/* 左边 left  end */
@media screen and (max-width:1200px) {
 .productRightText{
   line-height: 30px;
 }
}

</style>



// WEBPACK FOOTER //
// src/view/CaseDetailWanDa.vue